import React from "react";
import { RequireAuth } from "components/RequireAuth";
import { Navigate } from "react-router";
import {
    Dashboard as DashboardView,
    UserList as UserListView,
    InvoiceReport as InvoiceReportView,
    ExternalSignIn as SignInView,
    ConfigureAndSpend as ConfigureAndSpendView,
    QueueConfigList as QueueConfigListView,
    DGPList as DGPListView,
    DGPDetails as DGPDetailsView,
    AnalyticsList as AnalyticsListView,
    DidimosSearch as DidimosSearchView,
    AccessRequestList as AccessRequestListView,
    PackageList as PackageListView,
    PackageDetails as PackageDetailsView,
    PackageUpload as PackageUploadView
} from "views";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";
import UserDetails from 'views/UserList/UserDetails';
import UserBasicRegistrationForm from 'views/UserList/UserBasicRegistrationForm';

const routes = () => {
    return [
        { path: '/', element: <Navigate replace to="/dashboard" /> },
        { path: '/dashboard', element: <RequireAuth userGroup="Employees"><MainLayout><DashboardView /></MainLayout></RequireAuth> },
        { path: '/accounts', element: <RequireAuth userGroup="Administrators"><MainLayout><UserListView /></MainLayout></RequireAuth> },
        { path: '/access-requests', element: <RequireAuth userGroup="Administrators"><MainLayout><AccessRequestListView /></MainLayout></RequireAuth> },
        {
            path: '/accounts/new',
            element: <RequireAuth userGroup="Administrators"><MainLayout><UserBasicRegistrationForm /></MainLayout></RequireAuth>
        },
        {
            path: '/accounts/:uuid',
            element: <RequireAuth userGroup="Administrators"><MainLayout><UserDetails /></MainLayout></RequireAuth>
        },
        {
            path: '/didimos',
            element: <RequireAuth userGroup="Administrators"><MainLayout><DidimosSearchView /></MainLayout></RequireAuth>
        },
        {
            path: '/dgps',
            element: <RequireAuth userGroup="Administrators"><MainLayout><DGPListView /></MainLayout></RequireAuth>
        },
        {
            path: '/dgps/:uuid',
            element: <RequireAuth userGroup="Administrators"><MainLayout><DGPDetailsView /></MainLayout></RequireAuth>
        },
        { path: '/dgps/queues', element: <RequireAuth userGroup="Administrators"><MainLayout><QueueConfigListView /></MainLayout></RequireAuth> },
        {
            path: '/packages',
            element: <RequireAuth userGroup="Administrators"><MainLayout><PackageListView /></MainLayout></RequireAuth>
        },
        {
            path: '/packages/:application',
            element: <RequireAuth userGroup="Administrators"><MainLayout><PackageListView /></MainLayout></RequireAuth>
        },
        {
            // React Router 6 ranks static segments above dynamic ones, so this
            // wins over /packages/:application/:uuid below.
            path: '/packages/:application/upload',
            element: <RequireAuth userGroup="Administrators"><MainLayout><PackageUploadView /></MainLayout></RequireAuth>
        },
        {
            path: '/packages/:application/:uuid',
            element: <RequireAuth userGroup="Administrators"><MainLayout><PackageDetailsView /></MainLayout></RequireAuth>
        },
        { path: '/analytics', element: <RequireAuth userGroup="Administrators"><MainLayout><AnalyticsListView /></MainLayout></RequireAuth> },
        { path: '/reports/orders', element: <RequireAuth userGroup="Employees"><MainLayout><InvoiceReportView /></MainLayout></RequireAuth> },
        { path: '/conf-and-spend', element: <RequireAuth userGroup="Administrators"><MainLayout><ConfigureAndSpendView /></MainLayout></RequireAuth> },
        {
            path: "/profile/login",
            element: <MinimalLayout><SignInView /></MinimalLayout>
        },
        { path: '*', element: <Navigate replace to="/" /> },
    ]
};

export default routes;